export default __webpack_public_path__ + "static/media/content1.32b89d7c.png";